import React from "react";
import ShopPageComponent from "../components/shop/index";

const ShopPage = () => {
  return (
    <>
      <ShopPageComponent />
    </>
  );
};

export default ShopPage;
